import {
  Box,
  Card,
  FormHelperText,
  Grid,
  InputLabel,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputField from "../../../common/InputField";
import "./CareDirective.scss";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../common/Buttons";
import {
  setCareDirectiveData,
  getCareDirectiveData,
} from "../../../services/documentServices";
import styled from "@emotion/styled";
import { toast } from "react-hot-toast";
import {
  getUserIdFromLocalStorage,
  setStepStatus,
} from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const StyledInput = styled(InputField)`
  & .MuiOutlinedInput-notchedOutline {
    border-color: #d8d8d8;
  }
`;

const FoodDrink = ({ next, setButtonDisabled }) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    foodLike: "",
    foodDislike: "",
    drinkLike: "",
    drinkDislike: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const validate = Yup.object({
    foodLike: Yup.string().nullable(),
    foodDislike: Yup.string().nullable(),
    drinkLike: Yup.string().nullable(),
    drinkDislike: Yup.string().nullable(),
  });

  const handleSubmit = async (values) => {
    setButtonDisabled(true);
    const { stepStatus, careDirectiveId, foodDrinkId, ...rest } = values;
    const payload = {
      ...data,
      foodDrink: {
        ...rest,
        careDirectiveId,
        foodDrinkId,
        stepStatus: setStepStatus("00-00-0000", { ...rest }),
      },
    };
    const result = await setCareDirectiveData(payload, uID);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      next();
    }
    setButtonDisabled(false);
  };

  const handleSkipFun = async () => {
    next();
  };

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  const getCareDirectiveDataFun = async () => {
    setButtonDisabled(true);
    setIsLoading(true);
    try {
      const result = await getCareDirectiveData(uID);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (result.payLoad.foodDrink !== null) {
          setInitialValues(result.payLoad.foodDrink);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setButtonDisabled(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCareDirectiveDataFun();
  }, []);

  return (
    <Card className="care-directive documents-card-height summary-table">
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Grid container>
          <Grid
            item
            lg={7}
            md={6}
            sm={12}
            xs={12}
            className="outer outer-pt-10"
          >
            <Typography
              className="paragraph"
              color="color.magentaDark2"
              sx={{ mb: 2 }}
            >
              {t("cd-fd-text")}
            </Typography>
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={validate}
              onSubmit={(values) => handleSubmit(values)}
            >
              {(formik) => (
                <Form id="form_submit" onSubmit={formik.handleSubmit}>
                  <InputLabel sx={{ mt: 2, color: "color.magentaDark2" }}>
                    {t("cd-tab-1")}
                  </InputLabel>
                  <FormHelperText sx={{ color: "color.magentaDark2" }}>
                    {t("cd-fd-eat")}
                  </FormHelperText>
                  <StyledInput
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    name="foodLike"
                    type="text"
                  />
                  <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                    {t("cd-fd-eat-no")}
                  </FormHelperText>
                  <StyledInput
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    name="foodDislike"
                    type="text"
                  />
                  <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                    {t("cd-fd-drink")}
                  </FormHelperText>
                  <StyledInput
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    name="drinkLike"
                    type="text"
                  />
                  <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                    {t("cd-fd-drink-no")}
                  </FormHelperText>
                  <StyledInput
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    name="drinkDislike"
                    type="text"
                  />
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

export default FoodDrink;
